import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { ModelBase } from "@models";
import { 
  Character,
  CharacterFeature,
  PactBoon,
  CharacterPactBoon,
  PactBoonFeature,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import SelectObjectBox from "@components/input/selects/SelectObjectBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props {
  character: Character;
  obj: CharacterFeature;
  onChange: (changed: CharacterFeature) => void;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterPactBoonBox({
  character,
  obj,
  onChange,
}: Props) {
  const [my_obj, setObj] = useState(obj);

  const char_pb = my_obj.feature_options[0] as CharacterPactBoon;
  const pb_ff = my_obj.floating_feature as PactBoonFeature;
  return (
    <Grid container spacing={0} direction="column">
      <Grid>
        <SelectObjectBox
          name={my_obj.name}
          data_type="pact_boon"
          filter={{ 
            _id: { 
              "$in": pb_ff.pb_ids
            }
          }}
          value={char_pb.source_id}
          color={char_pb.source_id === "" ? "blue" : ""}
          display_format={"{obj.true_name}"}
          onChangeObject={ async (changed: ModelBase) => {
            if (changed instanceof PactBoon) {
              const new_obj = my_obj;
              if (char_pb.source) {
                char_util.removeCharFeatureBasesFor(character, char_pb);
                char_pb.char_feature_bases = [];
              }
              await api.loadObject(changed);
              await char_pb.copy_source({ char: character, feature_source: changed, parent_cf: new_obj });
              onChange(new_obj);
              setObj(new_obj);
            }
          }}
        />
      </Grid>
      { char_pb.source &&
        <Grid container spacing={0} direction="column">
          <Grid>
            { char_pb.name }
          </Grid>
          <Grid>
            <DisplayStringWithReplacements display_string={ char_pb.description } />
          </Grid>
        </Grid>
      }
    </Grid>
  );
}
